/**
 * Provides conditional show/hide functionality for DOM elements based on form input values.
 *
 * This class implements a flexible conditional display system where elements can be shown or hidden
 * based on the values of form inputs (text inputs, selects, checkboxes, radio buttons). Uses
 * data attributes to define conditions and supports various comparison operators.
 *
 * @remarks
 * - Elements with `data-show` attribute are monitored for conditional display
 * - Supports comparison operators: ===, ==, !=, >, >=, <, <=
 * - Handles text inputs, select elements, checkboxes, and radio button groups
 * - Automatically clears form values when elements are hidden
 * - Special handling for radio button groups to ensure proper exclusive behavior
 * - Uses CSS classes ('hide') and ARIA attributes for accessibility
 *
 * @example
 * // Expected HTML structure:
 * // <select id="userType">
 * //   <option value="admin">Administrator</option>
 * //   <option value="user">Regular User</option>
 * // </select>
 * //
 * // <div data-show="#userType == admin">
 * //   <p>Admin-only content</p>
 * // </div>
 * //
 * // <input type="checkbox" id="newsletter" />
 * // <div data-show="#newsletter == checked">
 * //   <p>Newsletter signup form</p>
 * // </div>
 *
 * // Initialization:
 * const showHidePlugin = new ShowHide();
 *
 * @public
 */
export class ShowHide {

  elements: Array<HTMLElement> = [];

  /**
   * Creates a new ShowHide instance and initializes conditional display functionality.
   *
   * @remarks Automatically scans for elements with data-show attributes and sets up event listeners
   */
  constructor() {
    //this.setupShowHide();
    this.initialize();
  }

  /**
   * Initializes the show/hide system by finding all conditional elements and setting up monitoring.
   *
   * @remarks Parses data-show attributes and establishes change event listeners on referenced form elements
   * @private
   */
  initialize = () => {
    this.elements = document.querySelectorAll("[data-show]") as unknown as Array<HTMLElement>;


    //console.log("showHide");
    ////console.log(`elements.count: ${this.elements.length}`);

    this.elements.forEach((elm, idx) => {
      let attr = elm.dataset.show;

      const rx = /(===|==|!=|>|>=|<|<=)/;

      const splitted = attr?.split(rx);

      ////console.log("splitted");
      ////console.log(splitted);

      if (splitted?.length === 3) {
        let refElementVal = splitted[0].trim();
        let val = splitted[2].trim();
        elm.dataset.showHideRefElement = refElementVal;
        elm.dataset.showHideOperator = splitted[1].trim();
        elm.dataset.showHideValue = val;

        let refElement: any = document.querySelector(refElementVal);


        if (refElement) {
          console.log(refElement);
          console.log(`val: ${val}`);
          //console.log(refElement.nodeName);
          // if (val != "checked") {
          //     if (refElement.value == val) {
          //         elm.classList.remove("hide");
          //     }else{
          //         elm.classList.add("hide");
          //     }
          // }else{
          //     //console.log("check if checked");
          //     if(refElement.checked) {
          //         //console.log("it's checked");
          //         elm.classList.remove("hide");
          //     }else{
          //         elm.classList.add("hide");
          //     }
          // }
          //this.refElementUpdated(refElement);
          refElement.onchange = (ev: Event) => {
            this.refElement_onChange(ev);
          }
          this.refElementUpdated(refElement);
        }

      }

      ///[#,\.A-Za-z0-9\-\_]+/
    });

  }

  refElement_onChange = (ev: Event) => {
    ////console.log("refElement changed");
    const elm = ev.target as HTMLElement;
    this.refElementUpdated(elm);
  }

  /**
   * Processes changes to a referenced form element and updates dependent show/hide elements.
   *
   * @param elm - The form element that changed (input, select, etc.)
   * @remarks Evaluates all conditional expressions referencing this element and shows/hides dependent elements accordingly
   * @private
   */
  refElementUpdated = (elm: HTMLElement) => {
    console.log("refElementUpdated");
    console.log(elm.id);
    const id = elm.id;
    let value = "";
    let checkedValue: boolean | null = null;
    let isRadio = false;
    let groupName = "";
    switch (elm.nodeName) {
      case "INPUT":
        let _input = (elm as HTMLInputElement);
        value = _input.value;
        if (_input.type == "checkbox" || _input.type == "radio") {
          checkedValue = _input.checked;
        }
        if (_input.type == "radio") {
          isRadio = true;
          groupName = _input.name;
        }
        break;
      case "SELECT":
        value = (elm as HTMLSelectElement).value;
        break;
    }

    //console.log(id);
    //console.log(`value: ${value}`);
    //console.log(`groupName: ${groupName}`);


    let childElements: Array<HTMLElement> = document.querySelectorAll(`[data-show-hide-ref-element="#${id}"]`) as unknown as Array<HTMLElement>;
    childElements.forEach((_ce, idx) => {
      let _val = _ce.dataset.showHideValue;
      let _operator = _ce.dataset.showHideOperator;

      //console.log(_ce);
      //console.log(`_val: ${_val}`);
      //console.log(`_operator: ${_operator}`);

      var show = false;

      console.log(`_val: ${_val}; value: ${value}`);

      if (_operator === "===" || _operator === "==") {

        show = (_val != "checked") ? _val?.toLowerCase() === value.toLowerCase() : checkedValue === true;

      } else if (_operator === "!=") {

        show = (_val != "checked" ? _val?.toLowerCase() != value.toLowerCase() : checkedValue === false);

      } else if (_operator === ">") {
        console.log("more than");
        show = !isNaN(parseInt(_val || '0')) && !isNaN(parseInt(value || '0')) ? parseInt(value || '0') > parseInt(_val || '0') : false;

      } else if (_operator === ">=") {
        console.log("more than equal");
        show = !isNaN(parseInt(_val || '0')) && !isNaN(parseInt(value || '0')) ? parseInt(value || '0') >= parseInt(_val || '0') : false;

      } else if (_operator === "<") {
        console.log("less than");
        show = !isNaN(parseInt(_val || '0')) && !isNaN(parseInt(value || '0')) ? parseInt(value || '0') < parseInt(_val || '0') : false;
      } else if (_operator === "<=") {
        console.log("less than equal");
        show = !isNaN(parseInt(_val || '0')) && !isNaN(parseInt(value || '0')) ? parseInt(value || '0') <= parseInt(_val || '0') : false;
      }

      if (groupName != "") {
        let _groupedItems = document.querySelectorAll(`[name="${groupName}"]`);
        _groupedItems.forEach((_gi) => {
          //hide if it's not referencing the element
          if (_gi.id != id) {
            let _gDependents = document.querySelectorAll(`[data-show-hide-ref-element="#${_gi.id}"]`);
            _gDependents.forEach((_gd) => {
              _gd.classList.add("hide");
              _gd.ariaHidden = "true";
              this.clearValues(_gd as HTMLElement);
            })
          }
        })
      }

      //console.log(`show: ${show}`);
      if (show) {
        _ce.classList.remove("hide");
        _ce.ariaHidden = "false";
      } else {
        _ce.classList.add("hide");
        _ce.ariaHidden = "true";
        this.clearValues(_ce);
      }

    })
  }

  /**
   * Clears all form values within a hidden element to prevent submission of invisible data.
   *
   * @param parent - The parent element containing form inputs to clear
   * @remarks Resets text inputs, selects to empty values and unchecks radio buttons and checkboxes
   * @private
   */
  clearValues = (parent: HTMLElement) => {
    let _inputs = parent.querySelectorAll("input, select");
    _inputs.forEach((_input: any) => {
      if (_input.type != "radio" || _input.type != "checkbox") {
        (_input as HTMLFormElement).value = "";
      } else {
        _input.checked = false;
      }
    })
  }

}